export default __webpack_public_path__ + "static/media/illustration-dashboard.f9aaf3db.png";